import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-bb-h",
  "use": "icon-bb-h-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-bb-h\"><path fill=\"currentColor\" d=\"M920 760H312c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h608c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM312 692h256c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM920 560H312c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h608c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM920 392H312c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h608c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM920 224H312c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h608c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 192h-64c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zM208 360h-64c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zM208 528h-64c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/bb-h.svg
// module id = fWe9
// module chunks = 101